import React, { useState, useEffect } from "react";

import axios from "axios";

import Select from "react-select";

import colors from "../Constants/colors";



const Result = () => {

  const [classes, setClasses] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");

  const [sections, setSections] = useState([]);

  const [selectedSection, setSelectedSection] = useState("");

  const [exams, setExams] = useState([]);

  const [selectedExam, setSelectedExam] = useState("");

  const [students, setStudents] = useState([]);

  const [subjects, setSubjects] = useState([]);

  const [subjectMarks, setSubjectMarks] = useState({});

  const [selectedSubjects, setSelectedSubjects] = useState([]);

  const [scores, setScores] = useState({});

  const [coScholasticAreas, setCoScholasticAreas] = useState([]);

  const [coScholasticGrades, setCoScholasticGrades] = useState({});

  const [isEditing, setIsEditing] = useState(false);

  const [editingResultId, setEditingResultId] = useState("");

  const [results, setResults] = useState([]);

  const [teacher, setTeacher] = useState(null);

  const [teacherClassIncharge, setTeacherClassIncharge] = useState("");

  const [assignedClass, setAssignedClass] = useState("");

  const [assignedSection, setAssignedSection] = useState("");

  const [isLoading, setIsLoading] = useState(false);



  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";

  const inputStyle =

    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";



  const isNurseryLkgUkg = (className) => {
    const normalized = String(className || "").trim().toLowerCase();
    return ["nursery", "lkg", "ukg"].includes(normalized);
  };

  // Foundation is hidden only for Nursery / LKG / UKG.
  // Class 1 onwards can show Foundation subjects.
  const isFoundationSubject = (subjectName) => {
    return /\bfoundation\s*$/i.test(String(subjectName || "").trim());
  };


useEffect(() => {

  // Get teacher info and sessionId from localStorage outside the async function

  const teacherRaw = localStorage.getItem("teacher");

  const sessionId = localStorage.getItem("currentSessionId");



  if (!teacherRaw || !sessionId) {

    console.error("Missing teacher or sessionId");

    return;

  }



  const teacherData = JSON.parse(teacherRaw);

  const teacherId = teacherData.id;



  if (!teacherId) {

    console.error("Teacher ID not found");

    return;

  }



  const fetchTeacher = async () => {

    try {

      // Fetch teacher data

      const response = await axios.get(

        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,

        { params: { sessionId } } // only sessionId as query param

      );



      setTeacher(response.data);



      // Teacher panel is restricted to the class + section where this

      // teacher is the Class Incharge.

      const classIncharge = String(response.data?.classIncharge || "").trim();



      let className = "";

      let sectionName = "";



      if (classIncharge.includes(" - ")) {

        const parts = classIncharge.split(" - ");

        className = String(parts[0] || "").trim();

        sectionName = String(parts.slice(1).join(" - ") || "").trim();

      } else {

        const match = classIncharge.match(/^(.+?)\s*\((.+)\)$/);

        if (match) {

          className = match[1].trim();

          sectionName = match[2].trim();

        }

      }



      setTeacherClassIncharge(classIncharge);

      setAssignedClass(className);

      setAssignedSection(sectionName);



      if (className) {

        setSelectedClass(className);

        setSelectedSection(sectionName);

      }



      // Keep the teacher's assigned classes API call only as supporting data.

      const { firstName, lastName } = response.data;

      fetchClasses(`${firstName} ${lastName}`);

    } catch (err) {

      console.error("Error fetching teacher data:", err);

    }

  };



  fetchTeacher();

}, []);



const sessionId = localStorage.getItem("currentSessionId");

  const currentSessionId = sessionId;



  const fetchClasses = async (teacherName) => {

    try {

      const response = await axios.get(

        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,

        { params: { sessionId } }

      );

      setClasses(response.data);

    } catch (error) {

      console.error("Error fetching classes:", error);

    }

  };



  const fetchSubjects = async (className, sectionName = selectedSection) => {

    if (!teacher) return;

    try {

      const { firstName, lastName } = teacher;

      const response = await axios.get(

        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${firstName}%20${lastName}/${className}`,

        { params: { sessionId, sectionName } }

      );

      if (Array.isArray(response.data.subjects)) {

        const normalizedSubjects = response.data.subjects

          .map((s) => {

            if (typeof s === "string") return s;

            return s?.subjectName || s?.name || s?.subject || "";

          })

          .filter(Boolean);



        setSubjects([...new Set(normalizedSubjects)]);

      } else {

        setSubjects([]);

      }

    } catch (error) {

      console.error("Error fetching subjects:", error);

    }

  };



  // Load the teacher's subjects from the selected DateSheet.

  // Co-Scholastic Areas also come directly from the DateSheet.

  const loadExamSubjects = async (

    className,

    examName,

    sectionName = selectedSection,

    editingSubjects = [],

    editingCoAreas = []

  ) => {

    if (!className || !examName || !teacher) return;



    try {

      const { firstName, lastName } = teacher;

      const teacherName = `${firstName} ${lastName}`;



      const [teacherSubjectsRes, examRes] = await Promise.all([

        axios.get(

          `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${encodeURIComponent(

            teacherName

          )}/${encodeURIComponent(className)}`,

          { params: { sessionId, sectionName } }

        ),

        axios.get(

          `${process.env.REACT_APP_API_BASE_URL}/api/exams/getExamByClass/${encodeURIComponent(

            className

          )}`,

          { params: { sessionId } }

        ),

      ]);



      const teacherSubjects = Array.isArray(teacherSubjectsRes.data?.subjects)

        ? teacherSubjectsRes.data.subjects

            .map((s) =>

              typeof s === "string"

                ? { subjectName: s, totalMarks: 0 }

                : {

                    subjectName:

                      s?.subjectName || s?.name || s?.subject || "",

                    totalMarks:

                      Number(s?.totalMarks || s?.maxMarks || 0),

                  }

            )

            .filter((s) => s.subjectName)

        : [];



      const selectedExamData = (examRes.data || []).find(

        (exam) => exam.examName === examName

      );



      const dateSheetSubjects = Array.isArray(selectedExamData?.subjects)

        ? selectedExamData.subjects

            .map((s) =>

              typeof s === "string"

                ? { subjectName: s, totalMarks: 0 }

                : {

                    subjectName:

                      s?.subjectName || s?.name || s?.subject || "",

                    totalMarks:

                      Number(s?.totalMarks || s?.maxMarks || 0),

                  }

            )

            .filter((s) => s.subjectName)

        : [];



      // Same as Admin Exam Result: show ALL subjects configured in the

      // selected Exam DateSheet. Teacher restriction is only Class Incharge

      // class/section; subjects are not filtered by teacher subject assignment.

      const sourceSubjects = dateSheetSubjects.length
        ? dateSheetSubjects
        : teacherSubjects;

      // Nursery / LKG / UKG should not get Foundation subjects.
      // Class 1 onwards keeps Foundation subjects.
      const allowed = isNurseryLkgUkg(className)
        ? sourceSubjects.filter(
            (subject) => !isFoundationSubject(subject.subjectName)
          )
        : sourceSubjects;



      // During edit, keep old result subjects too. This means a subject that

      // was already saved never disappears from the edit form.

      const mergedSubjects = [...allowed];

      (editingSubjects || []).forEach((oldSubject) => {

        const oldName =

          typeof oldSubject === "string"

            ? oldSubject

            : oldSubject?.subjectName;



        if (!oldName) return;



        const exists = mergedSubjects.some(

          (item) =>

            String(item.subjectName).trim().toLowerCase() ===

            String(oldName).trim().toLowerCase()

        );



        // Do not bring an old Foundation subject back into
        // Nursery / LKG / UKG edit mode.
        if (
          isNurseryLkgUkg(className) &&
          isFoundationSubject(oldName)
        ) {
          return;
        }

        if (!exists) {

          mergedSubjects.push({

            subjectName: oldName,

            totalMarks: Number(oldSubject?.totalMarks || 0),

          });

        }

      });



      const uniqueSubjects = mergedSubjects.filter(

        (subject, index, arr) =>

          arr.findIndex(

            (item) =>

              String(item.subjectName).trim().toLowerCase() ===

              String(subject.subjectName).trim().toLowerCase()

          ) === index

      );



      setSubjects(uniqueSubjects.map((s) => s.subjectName));



      const dateSheetMarks = {};

      dateSheetSubjects.forEach((s) => {

        dateSheetMarks[s.subjectName] = s.totalMarks || 0;

      });



      // Existing marks always win. New DateSheet subjects get their DateSheet

      // maximum marks automatically.

      setSubjectMarks((prev) => {

        const next = { ...dateSheetMarks, ...prev };

        (editingSubjects || []).forEach((s) => {

          const name = typeof s === "string" ? s : s?.subjectName;

          if (name && next[name] === undefined) {

            next[name] = Number(s?.totalMarks || 0);

          }

        });

        return next;

      });



      const currentAreas = Array.isArray(selectedExamData?.coScholasticAreas)

        ? selectedExamData.coScholasticAreas

            .map((area) =>

              typeof area === "string" ? area.trim() : String(area?.name || "").trim()

            )

            .filter(Boolean)

        : [];



      // Preserve old result areas and add any newly configured DateSheet areas.

      const mergedAreas = [...currentAreas, ...(editingCoAreas || [])].filter(

        (area, index, arr) =>

          area &&

          arr.findIndex(

            (item) =>

              String(item).trim().toLowerCase() ===

              String(area).trim().toLowerCase()

          ) === index

      );



      setCoScholasticAreas(mergedAreas);



      if (!isEditing && editingSubjects.length === 0) {

        setSelectedSubjects(

          uniqueSubjects.map((subject) => ({

            value: subject.subjectName,

            label: subject.subjectName,

          }))

        );

      } else if (editingSubjects.length > 0) {

        setSelectedSubjects(

          uniqueSubjects.map((subject) => ({

            value: subject.subjectName,

            label: subject.subjectName,

          }))

        );

      }

    } catch (error) {

      console.error("Error loading teacher/date-sheet subjects:", error);

      setSubjects([]);

      setCoScholasticAreas([]);

    }

  };



  useEffect(() => {

    // Only the teacher's Class Incharge class/section can be used here.

    if (!assignedClass || !currentSessionId) return;



    setSelectedClass(assignedClass);

    setSelectedSection(assignedSection);



    axios

      .get(

        `${process.env.REACT_APP_API_BASE_URL}/api/exams/getExamByClass/${encodeURIComponent(assignedClass)}`,

        { params: { sessionId: currentSessionId } }

      )

      .then((response) => setExams(Array.isArray(response.data) ? response.data : []))

      .catch((error) => {

        console.error("Error fetching exams:", error);

        setExams([]);

      });

  }, [assignedClass, assignedSection, currentSessionId]);



  useEffect(() => {

    if (selectedClass && selectedSection && selectedExam && teacher) {

      loadExamSubjects(selectedClass, selectedExam, selectedSection);

    }

  }, [selectedClass, selectedSection, selectedExam, teacher]);



  useEffect(() => {

    if (!assignedClass || !assignedSection || !currentSessionId) {

      setStudents([]);

      return;

    }



    // Always fetch students only for the teacher's Class Incharge class/section.

    axios

      .get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {

        params: {

          sessionId: currentSessionId,

          class: assignedClass,

          section: assignedSection,

          status: "active",

        },

      })

      .then((response) => {

        const data = Array.isArray(response.data)

          ? response.data

          : response.data?.students || [];



        const filtered = data.filter(

          (s) =>

            String(s.class).trim() === String(assignedClass).trim() &&

            String(s.section).trim() === String(assignedSection).trim() &&

            s.status === "active"

        );



        setStudents(filtered);

      })

      .catch((error) => {

        console.error("Error fetching students:", error);

        setStudents([]);

      });

  }, [assignedClass, assignedSection, currentSessionId]);



  const handleSubjectMarksChange = (subjectName, value) => {

    setSubjectMarks((prev) => ({ ...prev, [subjectName]: value }));

  };



  const handleScoreChange = (studentId, subjectName, type, value) => {

    setScores((prev) => ({

      ...prev,

      [studentId]: {

        ...prev[studentId],

        [subjectName]: {

          ...prev[studentId]?.[subjectName],

          [type]: value,

        },

      },

    }));

  };





  const handleCoScholasticChange = (studentId, area, value) => {

    setCoScholasticGrades((prev) => ({

      ...prev,

      [studentId]: {

        ...prev[studentId],

        [area]: value,

      },

    }));

  };



  const getCoScholasticGrade = (studentId, area) =>

    coScholasticGrades?.[studentId]?.[area] ?? "";



  const handleSubmit = async () => {

    // Hard UI-side guard: teacher can submit only for their Class Incharge class.

    if (

      !assignedClass ||

      !assignedSection ||

      String(selectedClass).trim() !== String(assignedClass).trim() ||

      String(selectedSection).trim() !== String(assignedSection).trim()

    ) {

      alert("You can add results only for your Class Incharge class and section.");

      return;

    }



    setIsLoading(true);



    const data = {

      sessionId,

      examName: selectedExam,

      className: assignedClass,

      sectionName: assignedSection,

      subjects: selectedSubjects.map((s) => ({

        subjectName: s.value,

        totalMarks: Number(subjectMarks[s.value]) || 0,

      })),

      students: students.map((stu) => ({

        studentId: stu._id,

        rollNo: stu.rollNo,

        studentName: `${stu.firstName} ${stu.lastName}`,

        scores: selectedSubjects.map((s) => {

          const sa = parseFloat(scores[stu._id]?.[s.value]?.sa) || 0;

          const oral = isNurseryLkgUkg(assignedClass)
            ? parseFloat(scores[stu._id]?.[s.value]?.oral) || 0
            : 0;

          const assessment =
            parseFloat(scores[stu._id]?.[s.value]?.assessment) || 0;

          return {
            subjectName: s.value,
            sa,
            oral,
            assessment,
            score: sa + oral + assessment,
          };
        }),

        coScholastic: coScholasticAreas.map((area) => ({

          area,

          grade: getCoScholasticGrade(stu._id, area),

        })),

      })),

      coScholasticAreas: coScholasticAreas.map((name) => ({ name })),

    };



    try {

      const response =

        isEditing && editingResultId

          ? await axios.put(

              `${process.env.REACT_APP_API_BASE_URL}/api/examresults/updateExamResult/${editingResultId}`,

              data

            )

          : await axios.post(

              `${process.env.REACT_APP_API_BASE_URL}/api/examresults/createExamResult`,

              data

            );



      const savedResult = response.data;

      if (isEditing && editingResultId) {

        setResults((prev) =>

          prev.map((item) =>

            item._id === editingResultId ? savedResult : item

          )

        );

      } else if (savedResult) {

        setResults((prev) => [savedResult, ...prev]);

      }



      alert(isEditing ? "Result updated successfully!" : "Result saved successfully!");

      clearForm();

    } catch (error) {

      console.error("Error saving result:", error);

      alert(error?.response?.data?.message || "Operation failed");

    } finally {

      setIsLoading(false);

    }

  };



  const fetchResults = async () => {

    try {

      const response = await axios.get(

        `${process.env.REACT_APP_API_BASE_URL}/api/examresults/getAllExamResults`,

        { params: { sessionId } }

      );

      const allResults = Array.isArray(response.data) ? response.data : [];

      setResults(

        allResults.filter(

          (result) =>

            String(result.className).trim() === String(assignedClass).trim() &&

            String(result.sectionName).trim() === String(assignedSection).trim()

        )

      );

    } catch (error) {

      console.error("Error fetching exam results:", error);

      setResults([]);

    }

  };



  const handleEdit = async (r) => {

    // A teacher can edit only results of the class/section where they are

    // currently the Class Incharge.

    if (

      String(r.className).trim() !== String(assignedClass).trim() ||

      String(r.sectionName).trim() !== String(assignedSection).trim()

    ) {

      alert("You can manage results only for your Class Incharge class and section.");

      return;

    }



    setSelectedClass(assignedClass);

    setSelectedSection(assignedSection);

    setSelectedExam(r.examName);

    setEditingResultId(r._id);

    setIsEditing(true);



    const oldSubjects = Array.isArray(r.subjects) ? r.subjects : [];



    const oldSubjectMarks = oldSubjects.reduce(

      (a, s) => ({ ...a, [s.subjectName]: s.totalMarks }),

      {}

    );



    const scoresMap = {};

    const coGradesMap = {};



    (r.students || []).forEach((student) => {

      const studentId = student.studentId?._id || student.studentId;



      scoresMap[studentId] = (student.scores || []).reduce(

        (a, score) => ({

          ...a,

          [score.subjectName]: {

            sa: score.sa ?? score.saMarks ?? 0,

            oral: score.oral ?? score.oralMarks ?? 0,

            assessment: score.assessment ?? score.assessmentMarks ?? 0,

          },

        }),

        {}

      );



      coGradesMap[studentId] = (student.coScholastic || []).reduce(

        (a, item) => ({

          ...a,

          [item.area || item.name]: item.grade ?? item.gradeValue ?? "",

        }),

        {}

      );

    });



    setScores(scoresMap);

    setCoScholasticGrades(coGradesMap);

    setSubjectMarks(oldSubjectMarks);



    const oldCoAreas = Array.isArray(r.coScholasticAreas)

      ? r.coScholasticAreas

          .map((area) =>

            typeof area === "string" ? area.trim() : String(area?.name || "").trim()

          )

          .filter(Boolean)

      : [];



    setCoScholasticAreas(oldCoAreas);

    setSelectedSubjects(

      oldSubjects.map((s) => ({

        value: s.subjectName,

        label: s.subjectName,

      }))

    );



    // Refresh from the latest DateSheet. Newly added subjects/areas are merged

    // into the old result without removing any saved marks or grades.

    await loadExamSubjects(

      r.className,

      r.examName,

      r.sectionName,

      oldSubjects,

      oldCoAreas

    );

  };



  const handleDelete = async (id) => {

    const result = results.find((item) => String(item._id) === String(id));



    if (

      result &&

      (String(result.className).trim() !== String(assignedClass).trim() ||

        String(result.sectionName).trim() !== String(assignedSection).trim())

    ) {

      alert("You can manage results only for your Class Incharge class and section.");

      return;

    }



    if (!window.confirm("Delete this result?")) return;

    try {

      await axios.delete(

        `${process.env.REACT_APP_API_BASE_URL}/api/examresults/deleteExamResult/${id}`

      );

      alert("Result deleted!");

      setResults((prev) => prev.filter((item) => item._id !== id));

    } catch (error) {

      console.error("Error deleting:", error);

    }

  };



  const clearForm = () => {

    // Keep the Class Incharge class/section locked in the teacher panel.

    setSelectedClass(assignedClass);

    setSelectedSection(assignedSection);

    setSelectedExam("");

    setSelectedSubjects([]);

    setSubjectMarks({});

    setScores({});

    setCoScholasticAreas([]);

    setCoScholasticGrades({});

    setEditingResultId("");

    setIsEditing(false);

  };



  useEffect(() => {

    if (assignedClass && assignedSection && currentSessionId) {

      fetchResults();

    }

  }, [assignedClass, assignedSection, currentSessionId]);



  const handleInputChange = () => {

    // Class/Section are intentionally locked to the teacher's Class Incharge assignment.

    setSelectedClass(assignedClass);

    setSelectedSection(assignedSection);

  };

const getFilteredResults = () => {

  // 🚫 Do not show anything until class & exam are selected

  if (!selectedClass || !selectedExam) return [];



  return results.filter(

    (r) =>

      String(r.className).trim() === String(assignedClass).trim() &&

      String(r.sectionName).trim() === String(assignedSection).trim() &&

      r.examName === selectedExam

  );

};



  return (

    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">

      {/* Header */}

      <div className="flex items-center justify-between mb-4">

        <div className="flex items-center gap-2">

          <i className="fas fa-graduation-cap text-blue-600 !text-[20px]" />

          <h1 className="font-bold !text-[18px]">Exam Results</h1>

        </div>

        {isEditing && (

          <span className="text-sm text-gray-500">

            Editing result –{" "}

            <span className="font-semibold">Update mode</span>

          </span>

        )}

      </div>

      <p className="text-gray-600 mb-6 !text-[14px]">

        Manage exam results only for your assigned Class Incharge class and section.

      </p>

      <div className="mb-6 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-[14px] text-blue-800">

        <span className="font-semibold">Class Incharge:</span>{" "}

        {teacherClassIncharge || "No Class Incharge assigned"}

        <span className="ml-2">

          — You can add, edit, and delete results only for this class and section.

        </span>

      </div>



      {/* Result Entry Card */}

      <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200 mb-8">

        <div className="flex items-center mb-4 gap-2">

          <i className="fas fa-file-alt text-blue-600 !text-[18px]" />

          <h2 className="font-semibold !text-[18px] text-gray-800">

            {isEditing ? "Edit Exam Result" : "Add New Exam Result"}

          </h2>

        </div>



        {/* Class & Exam */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          <div className="flex flex-col">

            <label className={labelStyle}>Class:</label>

            <div

              className={`${inputStyle} bg-gray-100 cursor-not-allowed flex items-center`}

              title="Class is locked to your Class Incharge assignment"

            >

              {assignedClass

                ? `${assignedClass}${assignedSection ? ` (${assignedSection})` : ""}`

                : "No Class Incharge Assigned"}

            </div>

          </div>



          <div className="flex flex-col">

            <label className={labelStyle}>Exam Name:</label>

            <select

              value={selectedExam}

              onChange={(e) => setSelectedExam(e.target.value)}

              className={inputStyle}

            >

              <option value="">Select Exam</option>

              {exams.map((exam) => (

                <option key={exam._id} value={exam.examName}>

                  {exam.examName}

                </option>

              ))}

            </select>

          </div>

        </div>



        {/* Subjects Multi-select */}

        <div className="mt-6">

          <label className={labelStyle}>Subjects:</label>

          <div className="border rounded-lg px-2 py-1">

            <Select

              isMulti

              options={subjects.map((s) => ({ value: s, label: s }))}

              value={selectedSubjects}

              onChange={setSelectedSubjects}

              classNamePrefix="react-select"

            />

          </div>

        </div>



        {/* Subject Marks Table */}

        {selectedSubjects.length > 0 && (

          <div className="mt-6 overflow-x-auto">

            <h3 className="font-semibold !text-[16px] mb-2 text-gray-800 flex items-center gap-2">

              <i className="fas fa-clipboard-list text-blue-600" />

              Subject Marks

            </h3>

            <table className="min-w-full border border-gray-300 text-center !text-[14px] bg-white">

              <thead className="bg-gray-100 text-gray-800">

                <tr>

                  <th className="border px-4 py-2 font-semibold">

                    Subject

                  </th>

                  <th className="border px-4 py-2 font-semibold">

                    Total Marks

                  </th>

                </tr>

              </thead>

              <tbody>

                {selectedSubjects.map((sub) => (

                  <tr key={sub.value} className="border-b">

                    <td className="border px-4 py-2">{sub.label}</td>

                    <td className="border px-4 py-2">

                      <input

                        type="number"

                        value={subjectMarks[sub.value] || ""}

                        onChange={(e) =>

                          handleSubjectMarksChange(

                            sub.value,

                            e.target.value

                          )

                        }

                        className={`${inputStyle} !px-2 !py-1`}

                      />

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}



        {/* Student Scores Table */}

        {students.length > 0 && selectedSubjects.length > 0 && (

          <div className="mt-8 overflow-x-auto">

            <h3 className="font-semibold !text-[16px] mb-2 text-gray-800 flex items-center gap-2">

              <i className="fas fa-user-graduate text-green-600" />

              Student Scores

            </h3>



            <table className="min-w-full border border-gray-300 text-center !text-[14px] bg-white">

              <thead className="bg-gray-100 text-gray-800">

                <tr>

                  <th rowSpan="2" className="border px-3 py-2 font-semibold">#</th>

                  <th rowSpan="2" className="border px-3 py-2 font-semibold">Roll No</th>

                  <th rowSpan="2" className="border px-3 py-2 font-semibold">Student</th>



                  {selectedSubjects.map((sub) => (

                    <th

                      key={sub.value}

                      colSpan={isNurseryLkgUkg(assignedClass) ? 3 : 2}

                      className="border px-3 py-2 font-semibold"

                    >

                      {sub.label}

                    </th>

                  ))}



                  {coScholasticAreas.map((area) => (

                    <th

                      key={`co-head-${area}`}

                      rowSpan="2"

                      className="border px-3 py-2 font-semibold min-w-[120px]"

                    >

                      {area}

                    </th>

                  ))}

                </tr>



                <tr>

                  {selectedSubjects.map((sub) => (

                    <React.Fragment key={`${sub.value}-marks-header`}>

                      <th className="border px-3 py-1 text-xs">
                        {isNurseryLkgUkg(assignedClass) ? "Written" : "SA"}
                      </th>

                      {isNurseryLkgUkg(assignedClass) && (
                        <th className="border px-3 py-1 text-xs">Oral</th>
                      )}

                      <th className="border px-3 py-1 text-xs">Assessment</th>

                    </React.Fragment>

                  ))}

                </tr>

              </thead>



              <tbody>

                {students.map((stu, i) => (

                  <tr key={stu._id} className="border-b">

                    <td className="border px-3 py-2">{i + 1}</td>

                    <td className="border px-3 py-2">{stu.rollNo}</td>

                    <td className="border px-3 py-2 whitespace-nowrap">

                      {stu.firstName} {stu.lastName}

                    </td>



                    {selectedSubjects.map((sub) => (

                      <React.Fragment key={sub.value}>

                        <td className="border px-2 py-2">

                          <input

                            type="number"

                            min="0"

                            max={subjectMarks[sub.value] || undefined}

                            value={scores[stu._id]?.[sub.value]?.sa ?? ""}

                            onChange={(e) =>

                              handleScoreChange(

                                stu._id,

                                sub.value,

                                "sa",

                                e.target.value

                              )

                            }

                            className={`${inputStyle} !px-2 !py-1 !w-[75px]`}

                          />

                        </td>



                        {isNurseryLkgUkg(assignedClass) && (
                        <td className="border px-2 py-2">
                          <input
                            type="number"
                            min="0"
                            max={subjectMarks[sub.value] || undefined}
                            value={scores[stu._id]?.[sub.value]?.oral ?? ""}
                            onChange={(e) =>
                              handleScoreChange(
                                stu._id,
                                sub.value,
                                "oral",
                                e.target.value
                              )
                            }
                            className={`${inputStyle} !px-2 !py-1 !w-[75px]`}
                          />
                        </td>
                      )}

<td className="border px-2 py-2">

                          <input

                            type="number"

                            min="0"

                            max={subjectMarks[sub.value] || undefined}

                            value={scores[stu._id]?.[sub.value]?.assessment ?? ""}

                            onChange={(e) =>

                              handleScoreChange(

                                stu._id,

                                sub.value,

                                "assessment",

                                e.target.value

                              )

                            }

                            className={`${inputStyle} !px-2 !py-1 !w-[90px]`}

                          />

                        </td>

                      </React.Fragment>

                    ))}



                    {coScholasticAreas.map((area) => (

                      <td

                        key={`${stu._id}-${area}`}

                        className="border px-2 py-2 min-w-[120px]"

                      >

                        <select

                          value={getCoScholasticGrade(stu._id, area)}

                          onChange={(e) =>

                            handleCoScholasticChange(

                              stu._id,

                              area,

                              e.target.value

                            )

                          }

                          className={`${inputStyle} !px-2 !py-1 !w-[100px] bg-white`}

                        >

                          <option value="">Grade</option>

                          <option value="A+">A+</option>

                          <option value="A">A</option>

                          <option value="B+">B+</option>

                          <option value="B">B</option>

                          <option value="C+">C+</option>

                          <option value="C">C</option>

                          <option value="D">D</option>

                          <option value="E">E</option>

                        </select>

                      </td>

                    ))}

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}



        {/* Buttons */}

        <div className="flex justify-end gap-4 mt-6">

          {isEditing && (

            <button

              onClick={clearForm}

              className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg !text-[14px]"

            >

              Cancel

            </button>

          )}

          <button

            onClick={handleSubmit}

            disabled={isLoading}

            className="text-white px-4 py-2 rounded-lg !text-[14px] hover:opacity-90"

            style={{ background: colors.gradientPrimary }}

          >

            {isLoading

              ? "Saving..."

              : isEditing

              ? "Update Result"

              : "Save Result"}

          </button>

        </div>

      </div>



      {/* All Results Card */}

      <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">

        <div className="flex items-center gap-2 mb-4">

          <i className="fas fa-table text-green-600 !text-[18px]" />

          <h2 className="font-semibold !text-[18px] text-gray-800">

            All Exam Results

          </h2>

        </div>



       {selectedClass && selectedExam ? (

  getFilteredResults().length > 0 ? (

    <div className="overflow-x-auto">

      <table className="min-w-full border border-gray-300 text-center !text-[14px] bg-white">

        <thead className="bg-gray-100 text-gray-800">

          <tr>

            <th className="border px-4 py-2">#</th>

            <th className="border px-4 py-2">Exam</th>

            <th className="border px-4 py-2">Class</th>

            <th className="border px-4 py-2">Section</th>

            <th className="border px-4 py-2">Subjects</th>

            <th className="border px-4 py-2">Actions</th>

          </tr>

        </thead>

        <tbody>

          {getFilteredResults().map((res, i) => (

            <tr key={res._id} className="border-b hover:bg-gray-50">

              <td className="border px-4 py-2">{i + 1}</td>

              <td className="border px-4 py-2">{res.examName}</td>

              <td className="border px-4 py-2">{res.className}</td>

              <td className="border px-4 py-2">{res.sectionName}</td>

              <td className="border px-4 py-2">

                {res.subjects.map((s) => s.subjectName).join(", ")}

              </td>

              <td className="border px-4 py-2">

                <div className="flex justify-center gap-2">

                  <button

                    onClick={() => handleEdit(res)}

                    className="bg-yellow-500 text-white px-3 py-1 rounded-lg !text-[13px]"

                  >

                    Edit

                  </button>

                  <button

                    onClick={() => handleDelete(res._id)}

                    className="bg-red-500 text-white px-3 py-1 rounded-lg !text-[13px]"

                  >

                    Delete

                  </button>

                </div>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  ) : (

    <p className="text-gray-600 !text-[14px]">

      No results found for selected class & exam.

    </p>

  )

) : (

  <p className="text-gray-500 !text-[14px]">

    Select class and exam to view results.

  </p>

)}



      </div>

    </div>

  );

};



export default Result;
